module.exports = __webpack_public_path__ + "img/rank2.bd10bf66.png";